export default __webpack_public_path__ + "static/media/web.7cdad17e.svg";